.tool-run {
  align-self: stretch;
}

.content {
  display: flex;
  flex-flow: column nowrap;
  row-gap: var(--mantine-spacing-xs);
  padding-inline-start: var(--mantine-spacing-lg);
  margin-inline-start: 8px;
  overflow: hidden;
  border-inline-start: 1px solid var(--mantine-color-dark-5);
}

.accordion-label {
  padding-block: 0;
}

.accordion-content {
  padding-block-end: 0;
}
